module.exports = require('./helpers/bundle-url').getBundleURL('5ijCj') + "sfe.07f1b3dd.jpg";